import { render, staticRenderFns } from "./RecipeInstructions.vue?vue&type=template&id=be6f695a&scoped=true&"
import script from "./RecipeInstructions.vue?vue&type=script&lang=js&"
export * from "./RecipeInstructions.vue?vue&type=script&lang=js&"
import style0 from "./RecipeInstructions.vue?vue&type=style&index=0&id=be6f695a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6f695a",
  null
  
)

export default component.exports